module.exports = __webpack_public_path__ + "static/media/instructor.910fe24e.png";